import type { DeepPartial } from '../../default/types';
import type { OrderConfig } from '../../default/order/order.types';
import { riskIdentSnippet } from '../../default/order/order';

export const orderConfig: DeepPartial<OrderConfig> = {
  paymentMethods: ['paypal', 'mastercard', 'visa', 'diners', 'discover'],
  hasCo2Compensation: false,
  externalUrls: {
    rsvAvb: {
      default: 'https://www.ottoversand.at/de/ratenschutz/avb/',
    },
    rsvIpid: {
      default: 'https://www.ottoversand.at/de/ratenschutz/ipid/',
    },
    rsvInfoVag: {
      default: 'https://www.ottoversand.at/de/ratenschutz/fernfing/',
    },
    rsvVvi: {
      default: 'https://www.ottoversand.at/de/ratenschutz/ruecktrittsrecht/',
    },
    rsvWithdrawalRight: {
      default: 'https://www.ottoversand.at/de/ratenschutz/ruecktrittsrecht/',
    },
    rsvDataProtection: {
      default: 'https://bnpparibascardif.at/datenschutz/',
    },
    flexikontoPaymentPause: {
      default: '/service-hilfe/service/bezahlung-und-finanzierung/flexikonto-zahlpause',
    },
  },
  premium: {
    enabled: false,
    hasRuntimeOptions: false,
    hasLegalFooter: true,
  },
  paylink: {
    paymentMethods: ['mastercard', 'visa', 'diners', 'discover'],
  },
  riskIdent: {
    enabled: true,
    snippetId: riskIdentSnippet('ETMm7f'),
  },
  sovendus: {
    de: {
      trafficSourceNumber: '1230',
      trafficMediumNumber: { default: '3', mobile: '5', app: '52' },
    },
  },
};
